import { ChainId as e } from "@deorderbook/contracts";
import { debug as n } from "./provider.mjs";
const a = {
  [e.ETH_MAINNET]: {
    default: "https://api.studio.thegraph.com/query/62577/dob-homestead-test/version/latest",
    next: "https://api.studio.thegraph.com/query/62577/dob-homestead-test/version/latest"
  },
  [e.ETH_SEPOLIA]: {
    default: "https://api.studio.thegraph.com/query/62577/dob-sepolia-test/version/latest",
    next: "https://api.studio.thegraph.com/query/62577/dob-sepolia-test/version/latest"
  },
  [e.SCROLL_SEPOLIA]: {
    default: "https://api.studio.thegraph.com/query/62577/dob-scroll-sepolia-test/version/latest",
    next: "https://api.studio.thegraph.com/query/62577/dob-scroll-sepolia-test/version/latest"
  }
}, t = {
  url: a[e.ETH_MAINNET].default,
  version: "default"
};
function d(u = e.ETH_MAINNET, s) {
  const { url: r, version: i } = s ?? {}, o = { url: "", version: void 0 };
  return r === void 0 || r === "" ? i !== void 0 && (o.url = a[u][i]) : o.url = r, o.version = s?.version ?? t.version, Object.assign(t, s, o), n && console.log("SUBGRAPH OPTIONS:", t), t;
}
function h() {
  return t.url;
}
export {
  a as SubgraphURLEnum,
  h as getSubgraphEndPoint,
  d as setupSubgraph,
  t as subgraphOptions
};
//# sourceMappingURL=subgraph.mjs.map
